// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1u-2";
export var blackBorderOnHover = "_1u-7";
export var cell = "_1u-6";
export var cellContainer = "_1u-3";
export var checked = "_1u-8";
export var disabled = "_1u-5";
export var featuredIconCellContainer = "_1u-9";
export var featuredIconTextContainer = "_1u-b";
export var featuredIconWrapper = "_1u-a";
export var noBorder = "_1u-c";
export var orangeSelectedRow = "_4r-3";
export var overflowableText = "_1u-0";
export var overflowableTextContainer = "_1u-1";
export var row = "_1v-0";
export var rowCheckboxCell = "_1u-4";
export var selectableTable = "_4r-2";